import { Provider } from 'react-redux';
import {
  i18nReducer,
  loadTranslations,
  setLocale,
  syncTranslationWithStore,
} from 'react-redux-i18n';

import { PedigreeImport } from './pedigree-import';
import { createStore } from '@common/utils/redux';
import { pedigreeImportEN } from './translations/en';
import { pedigreeImportES } from './translations/es';
import { pedigreeImportJA } from './translations/ja';
import { combineReducers } from 'redux';
import { initializeRootAndReturnRender, unmountReactNode } from '@common/utils/react';

export const initPedigreeImport = function (folderId, locale) {
  try {
    const store = createStore(combineReducers({ i18n: i18nReducer }));
  
    syncTranslationWithStore(store);
  
    const translation = {
      en: pedigreeImportEN,
      ja: pedigreeImportJA,
      es: pedigreeImportES,
    };
  
    if (!translation[locale]) {
      locale = 'en';
    }
  
    store.dispatch(loadTranslations(translation));
    store.dispatch(setLocale(locale));
  
    const container = document.createElement('div');

    document.body.appendChild(container);

    const { root, render } = initializeRootAndReturnRender(
      container
    );
    const close = () => unmountReactNode(root);

    render(
      <Provider store={store}>
        <PedigreeImport close={close} folderId={folderId} /> 
      </Provider>
    );
  } catch (err) {
    console.error(err);
  }
};
